/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { useUser } from '@clerk/clerk-react';
import * as Sentry from '@sentry/react';
import { RouterProvider } from 'react-router';

import Logo from './components/atoms/Logo';
import { router } from './routes';

const App = function () {
    const { user, isLoaded } = useUser();

    if (user && process.env.NODE_ENV === 'production') {
        const email = user.primaryEmailAddress?.emailAddress;
        if (email) {
            Sentry.setUser({ email });

            if (!email.includes('heal.dev')) {
                const replay = Sentry.getReplay();
                const replayId = replay?.getReplayId();
                if (replayId === undefined) replay?.start();
            }
        }
    }

    if (!isLoaded) {
        return (
            <div className="h-screen flex items-center justify-center">
                <Logo className="w-2/12 h-2/12 animate-pulse" />
            </div>
        );
    }

    return (
        <div className="App">
            <RouterProvider router={router} />
        </div>
    );
};

export default App;
